'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegYear = exports.getVehicleProp = exports.isManualOrLookup = exports.manufacturedFromYear = exports.regYear = exports.manualLookupValues = exports.manualLookupFetching = exports.manualLookupOptions = exports.manualLookupRequestError = exports.vehicleDescription = exports.vehicle = exports.vehicleLookupView = exports.cdlOptions = exports.cdlError = exports.cdlFetching = exports.vehicleLookup = undefined;
var _reselect = require('reselect');
var _constants = require('../constants');
var _fieldInfo = require('./field-info');
var vehicleLookup = exports.vehicleLookup = function vehicleLookup(state, formId) {
  return state[_constants.NAME][formId] ? state[_constants.NAME][formId].vehicleLookup : {};
};
var initialised = function initialised(state, formId) {
  return !!state[_constants.NAME][formId] && !!vehicleLookup(state, formId);
};
var cdlFetching = exports.cdlFetching = function cdlFetching(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).cdlFetching : false;
};
var cdlError = exports.cdlError = function cdlError(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).cdlError : false;
};
var cdlOptions = exports.cdlOptions = function cdlOptions(formId) {
  var original = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _reselect.createSelector)(function (state) {
    return initialised(state, formId);
  }, function (state) {
    return vehicleLookup(state, formId).cdlOptions;
  }, function (initialised, options) {
    if (!initialised) return [];
    return original ? options : options.map(function (vehicle, i) {
      return {
        value: i.toString(),
        text: vehicle.model.description
      };
    });
  });
};
var vehicleLookupView = exports.vehicleLookupView = function vehicleLookupView(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).view : 'regLookup';
};
var vehicle = exports.vehicle = function vehicle(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).vehicle : undefined;
};
var vehicleDescription = exports.vehicleDescription = function vehicleDescription(state, formId) {
  return vehicle(state, formId).description;
};
var manualLookupRequestError = exports.manualLookupRequestError = function manualLookupRequestError(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).manualError : false;
};
var manualLookupOptions = exports.manualLookupOptions = function manualLookupOptions(state, formId) {
  return initialised(state, formId) ? state[_constants.NAME][formId].vehicleLookup.manualOptions : undefined;
};
var manualLookupFetching = exports.manualLookupFetching = function manualLookupFetching(state, formId) {
  return initialised(state, formId) ? vehicleLookup(state, formId).manualFetching : undefined;
};
var manualLookupValues = exports.manualLookupValues = function manualLookupValues(state, formId) {
  return {
    manufacturer: (0, _fieldInfo.getValue)(state, formId, 'manufacturerOptions'),
    model: (0, _fieldInfo.getValue)(state, formId, 'modelOptions'),
    trans: (0, _fieldInfo.getValue)(state, formId, 'transOptions'),
    fuel: (0, _fieldInfo.getValue)(state, formId, 'fuelOptions'),
    engine: (0, _fieldInfo.getValue)(state, formId, 'engineOptions'),
    trim: (0, _fieldInfo.getValue)(state, formId, 'trimOptions'),
    doors: (0, _fieldInfo.getValue)(state, formId, 'doorsOptions'),
    abiCode: (0, _fieldInfo.getValue)(state, formId, 'yearOptions')
  };
};
var regYear = exports.regYear = function regYear(state, formId) {
  if (!initialised(state, formId)) return undefined;
  return vehicle(state, formId).regDate ? vehicle(state, formId).regDate.year : undefined;
};
var manufacturedFromYear = exports.manufacturedFromYear = function manufacturedFromYear(state, formId) {
  if (!initialised(state, formId)) return undefined;
  return vehicle(state, formId).manufacturedFromYear;
};
var isManualOrLookup = exports.isManualOrLookup = function isManualOrLookup(state, formId) {
  var v = vehicle(state, formId);
  if (typeof v !== 'undefined') {
    if (Object.prototype.hasOwnProperty.call(v, 'regNo')) {
      return 'lookup';
    }
    return 'manual';
  }
  return undefined;
};
var getVehicleProp = exports.getVehicleProp = function getVehicleProp(state, formId, prop) {
  var type = isManualOrLookup(state, formId);
  if (typeof type === 'undefined') {
    return undefined;
  }
  var v = vehicle(state, formId);
  return v[prop];
};
var getRegYear = exports.getRegYear = function getRegYear(state, formId) {
  var type = isManualOrLookup(state, formId);
  if (typeof type === 'undefined') {
    return undefined;
  }
  var v = vehicle(state, formId);
  if (type === 'lookup') {
    return v.regDate.year;
  }
  if (type === 'manual') {
    return v.manufacturedToYear;
  }
};